
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/products/details/[friendlyName]",
      function () {
        return require("private-next-pages/en/products/details/[friendlyName].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/products/details/[friendlyName]"])
      });
    }
  